"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _member = require("@/api/member/member");
var _commissionBaseDeductionSetting = require("@/api/orderManagement/commissionBaseDeductionSetting");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderDetails',
  data: function data() {
    return {
      activeName: 'first',
      dataList: {},
      order: {},
      splitList: [],
      queryData: {
        orderNo: '',
        unionCode: ''
      },
      PlatformType: {
        'TB': '淘宝',
        'JD': '京东',
        'PDD': '拼多多',
        'WPH': '唯品会',
        'DY': '抖音',
        'KS': '快手',
        'ELM': '饿了么',
        'MT': '美团',
        'ALI': '1688'
      },
      options: []
    };
  },
  created: function created() {
    this.queryData.orderNo = this.$route.query.orderNo;
    this.queryData.unionCode = this.$route.query.unionCode;
    this.loadOrderDetail();
    this.memberQueryMemberGradeApi();
  },
  methods: {
    refresh: (0, _validate.throttle)(function () {
      var _this = this;
      (0, _commissionBaseDeductionSetting.syncStatus)({
        orderNo: this.queryData.orderNo,
        unionCode: this.queryData.unionCode
      }).then(function (res) {
        _this.$notify.success({
          title: '温馨提示',
          message: '操作成功！请刷新页面查看同步结果 (数据更新可能延迟)'
        });
      });
    }, 2500),
    memberQueryMemberGradeApi: function () {
      var _memberQueryMemberGradeApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _member.memberQueryMemberGradeApi)();
            case 1:
              res = _context.v;
              this.options = res.data;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function memberQueryMemberGradeApi() {
        return _memberQueryMemberGradeApi2.apply(this, arguments);
      }
      return memberQueryMemberGradeApi;
    }(),
    onBlack: function onBlack() {
      localStorage.setItem('is_user_Order', true);
      var val = this.$route.query;
      console.log('this.$route.query.JumpType', val);
      if (this.$route.query.JumpType === 'NeedReturn') {
        localStorage.setItem('NeedReturnData', JSON.stringify({
          type: val.type,
          queryOrderNo: val.queryOrderNo,
          queryPlatform: val.queryPlatform,
          queryStatus: val.queryStatus,
          queryViolate: val.queryViolate
        }));
      }
      this.$router.go(-1);
    },
    loadOrderDetail: function () {
      var _loadOrderDetail2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context2.n = 1;
              return (0, _commissionBaseDeductionSetting.loadOrderDetail)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                // this.dataList = res.data.data
                this.order = res.data.order;
                this.splitList = res.data.splitList;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadOrderDetail() {
        return _loadOrderDetail2.apply(this, arguments);
      }
      return loadOrderDetail;
    }(),
    copyText: function () {
      var _copyText = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(text) {
        var _this2 = this;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              try {
                this.$copyText(text).then(function () {
                  _this2.$notify.success({
                    title: '温馨提示',
                    message: '拷贝成功'
                  });
                }).catch(function () {
                  _this2.$notify.success({
                    title: '温馨提示',
                    message: '拷贝失败，请手动复制'
                  });
                });
              } catch (err) {
                alert('拷贝失败，请手动复制');
                this.$notify.success({
                  title: '温馨提示',
                  message: '拷贝失败，请手动复制'
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function copyText(_x) {
        return _copyText.apply(this, arguments);
      }
      return copyText;
    }(),
    // 用户详情
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.splitMemberId,
          nickname: value.splitMemberName
        }
      });
    }
  }
};